

/******************************************************
	Forms
******************************************************/
import $ from 'jquery';
import validate from 'jquery-validation';


import autocomplete from 'jquery-ui/ui/widgets/autocomplete';

import Inputmask from "inputmask";

$.validator.addMethod('requiredMonth', function (value, element, param) {

    // Check if dependency is met
    if (!this.depend(param, element)) {
        return "dependency-mismatch";
    }
    if (element.nodeName.toLowerCase() === "select") {

        // Could be an array for select-multiple or a string, both are fine this way
        var val = $(element).val();
        return val && val.length > 0;
    }
    if (this.checkable(element)) {
        return this.getLength(value, element) > 0;
    }
    return value !== undefined && value !== null && value.length > 0;
}, 'The expiry month is required.');

$.validator.addClassRules("requiredMonth", { requiredMonth: true });

$.validator.addMethod('requiredYear', function (value, element, param) {
    // Check if dependency is met
    if (!this.depend(param, element)) {
        return "dependency-mismatch";
    }
    if (element.nodeName.toLowerCase() === "select") {

        // Could be an array for select-multiple or a string, both are fine this way
        var val = $(element).val();
        return val && val.length > 0;
    }
    if (this.checkable(element)) {
        return this.getLength(value, element) > 0;
    }
    return value !== undefined && value !== null && value.length > 0;
}, 'The expiry year is required.');

$.validator.addClassRules("requiredYear", { requiredYear: true });

export default function initForms() {
    if ($(".volunteerForm").length) {
        initVolunteerForm();
    }
    if ($(".donateForm").length) {

        initDonationForm();
    }
    if ($(".CartCCPaymentTable").length) {
        paymentGateway();
    }
    if ($(".volunteerRegisterStep1").length) {
        volunteerRegisterStep1();
    }
    if ($(".training-question").length) {
        $(".training-question .button").click(function (e) {
            if ($(".training-question input:checked").val() !== "true") {
                e.preventDefault();
                $(".training-question div.error").show();
            }
        });
    }
}
function volunteerRegisterStep1() {
    // create mask definitions based on classes set in CMSDesk
    $("input[class*='mask']").each(
        function () {
            var classNames = $(this).attr("class");
            var mask = classNames.substring(classNames.indexOf('mask') + 4);
            if (mask.indexOf(' ') > -1) {
                // if maskxxx class name not at end of class name list
                mask = mask.substring(0, mask.indexOf(' '));
            }

            var im = new Inputmask(mask.replace(/_/g, ' '));
            im.mask($(this));
        }
    );
}

function paymentGateway() {
    if ($(".PaymentCCNumber input").val().indexOf("eCrypted") != -1) {
        $(".PaymentCCNumber input").val("");
    }
    if ($(".PaymentCCV input").val().indexOf("eCrypted") != -1) {
        $(".PaymentCCV input").val("");
    }
    $("form").attr("data-eway-encrypt-key", $(".CartCCPaymentTable").data("encrypt"));
    $(".PaymentCCNumber input").attr("data-eway-encrypt-name", "p$lt$ctl01$pageplaceholder$p$lt$zoneContent$wPF$PaymentDataForm$txtCCNumber");
    $(".PaymentCCV input").attr("data-eway-encrypt-name", "p$lt$ctl01$pageplaceholder$p$lt$zoneContent$wPF$PaymentDataForm$txtCCV");
    var script = document.createElement("script");
    script.src = "https://secure.ewaypayments.com/scripts/eCrypt.js";
    document.head.appendChild(script);

}

function initDonationForm() {
    $("input[name='amount']").click(function () {
        $("input[name='realamount']").val($(this).val()).blur();
    });
    $(".tabs-title").click(function () {

        $("input[name='paymenttype']").val($(this).data("type"));
    });
    var oValidator = $("form").validate({
        errorPlacement: function (error, element) {
            if (element.attr("type") == "radio") {
                error.insertAfter(element.parents(".formCards--text:first"));
            } else if (element.hasClass("inline-month") || element.hasClass("inline-year")) {
                error.insertAfter(element.parents("label:first"));
            } else {
                error.insertAfter(element);
            }
        }
    });
    $(".donateForm__cta .button").click(function (e) {
         e.preventDefault();
       
        if ($("form").valid()) {
            $('#overlay').show();
            $(".donateForm__cta .button").disabled = true;

            $(this).prop('disabled', true);
            //$("#donate__button--span").html("Please wait...");
                       // encrypt
            var encryptkey = $("form").data("encrypt");
            var ccnumber = $("input[name='ccnumber']").val();
            var ccv = $("input[name='ccv']").val();
            if (jQuery("input[name='recurrence']:checked").val() == "OnceOnly") {
                $("input[name='ccnumber']").val(eCrypt.encryptValue(ccnumber, encryptkey));
                $("input[name='ccv']").val(eCrypt.encryptValue(ccv, encryptkey));
            }
            var datatosend = $("form").serialize();
            $("input[name='ccnumber']").val(ccnumber);
            $("input[name='ccv']").val(ccv);
            var action = $("form").attr("action");

            var realamount = $("input[name='realamount']").val();
            var company = $("input[name='company']").val();
            var donationID = $("input[name='donationID']").val();
            if (company == null) {
                company = "";
            }
            

            $.ajax({
                url: action.indexOf('?') == -1 ? action + "?ajax=true" : action + "&ajax=true",
                type: $("form").attr("method"),
                data: datatosend,
                success: function (response) {
                    if (response.success) {
                        $('#overlay').hide();
                        document.location.href = "/Donate/Donate-now/Thank-you?referrer=" + company;
                        // Datalayer for google tag manager
                        dataLayer.push({
                            'event': 'transaction',
                            'ecommerce': {
                                'purchase': {
                                    'actionField': {
                                        'id': response.payload.itemId,
                                        'revenue': realamount
                                    },
                                    'products': [{
                                        'name': 'Donation',
                                        'id': response.payload.itemId,
                                        'price': realamount,
                                        'category': 'Donation'
                                    }]
                                }
                            }
                        });
                    } else {
                        $('#overlay').hide();
                        $(".donateForm__cta .button").disabled = false;
                        $(".errorHolder").html(response.payload.paymentResult);
                        $("input[name='id']").val(response.payload.itemId);

                    }
                }
            });
           // $('#overlay').hide();
        }
    });
}

function initVolunteerForm() {
    var locations = [];

    $.getJSON("/Find-a-meal?locations=json", function (data) {
        if (data.locations.length) {
            // create location list
            $.each(data.locations, function (index, value) {
                locations.push({
                    label: value.title + ", " + value.address,
                    title: value.title,
                    address: value.address,
                });
            });


            // init the autocomplete
            $('.autocomplete').autocomplete({
                highlight: "active", // Or string with your own classname
                minLength: 3,
                source: locations,
                select: function (event, ui) {
                    $(event.target).val(ui.item.title);
                    var $selector = $(event.target).closest(".locationSelector");
                    var $selection = $(".locationSelector__selection", $selector);
                    $(".locationSelector__title", $selection).html(ui.item.title);
                    $(".locationSelector__address", $selection).html(ui.item.address);
                    $selector.addClass("selected");

                    var next = parseInt($selector.data("location")) + 1;
                    $(".locationSelector[data-location=" + next + "]").addClass("show");
                    return false;
                }
            });
        }
    });

    // clear a location selection
    $(".locationSelector__clear").on("click keyup", function (e) {
        if (e.which == 1 || e.which == 13) {
            var $selector = $(this).closest(".locationSelector").removeClass("selected");
            $selector.find(".locationSelector__input").val("");
        }
    });

    // toggle the guardian details panel for under 18's
    $("select[name='AgeBracket']").on("change", function () {
        if ($(this).val() === "Under18") {
            $(".guardianPanel").slideDown();
        } else {
            $(".guardianPanel").slideUp();
        }
    });

    // auto fill the guardian address on checkbox result
    $("input[name='GuardianSameAddress']").on("change", function () {
        if ($(this).is(":checked")) {
            $("input[name='GuardianAddress1']").val($("input[name='Address1']").val());
            $("input[name='GuardianAddress2']").val($("input[name='Address2']").val());
            setSelectValue($("select[name='GuardianState']"), $("select[name='State']").val());
            $("input[name='GuardianPostcode']").val($("input[name='Postcode']").val() || null);
        }
    });

    $("#ctl00_ContentPlaceHolder1_plcZones_lt_zoneCenter_VolunteerApplicationStep2_VolunteerBiz_btnOK").click(
        function () {
            $(this).hide();
        }
    );
}

// Set the value of a styled select list
function setSelectValue($el, value) {
    var $option = $el.find("option[value='" + value + "']");
    if ($option.length) {
        $el.val(value);
        $el.siblings(".select-styled").find("span").text($option.text());
    }
}

/******************************************************
	Same address...
******************************************************/
var $streetFields;
var $postalFields;

$(function () {
    $streetFields = $(".StreetAddy .streetaddycopy").find("input, select");
    $postalFields = $(".PostalAddy .streetaddycopy").find("input, select");

    $("#SameAsStreetAddy").change(function () {
        if ($("#SameAsStreetAddy:checked").length > 0) {
            $postalFields.attr("disabled", true);
            copyStreetAddress();
            $streetFields.on("change", copyStreetAddress);
        } else {
            $streetFields.off("change", copyStreetAddress);
            $postalFields.attr("disabled", null);
        }
    });
});

// copy the street address to the postal address
function copyStreetAddress() {
    // cycle through the inputs
    $streetFields.each(function (index, field) {
        var value = $(field).val();
        $postalFields.eq(index).val(value);
    });

    // set the visible select value
    setSelectValue($(".PostalAddy select"), $(".PostalAddy select").val());
};
